function buocDangNhap() {
  return [
    {
      target: "body",
      placement: "center",
      title: "Bước 1 · Đăng nhập",
      content:
        'Nhập email và mật khẩu do quản trị viên cấp. Có thể tick "Ghi nhớ đăng nhập" để không phải nhập lại mỗi lần mở máy.',
    },
    {
      target: "#tour-dang-nhap-ghi-nho",
      title: "Bước 2 · Ghi nhớ đăng nhập",
      content:
        "Không bắt buộc — chỉ nên tick nếu đây là máy tính/điện thoại riêng của bạn. Tránh tick trên máy dùng chung (ví dụ máy tính chung ở văn phòng) để không giữ đăng nhập cho người dùng sau.",
      placement: "top",
    },
    {
      target: "#tour-dang-nhap-quen-mat-khau",
      title: "Bước 3 · Quên mật khẩu",
      content:
        'Nếu quên mật khẩu, bấm "Quên mật khẩu?" — hệ thống gửi liên kết đặt lại qua email đăng nhập, kiểm tra cả hộp thư spam. Nếu chắc chắn đúng email/mật khẩu mà vẫn không đăng nhập được, có thể tài khoản đã bị Admin vô hiệu hoá — báo Admin để được mở lại.',
      placement: "top",
    },
  ];
}

export default buocDangNhap;
